var _navigator$language;
import "core-js/modules/es.array-buffer.detached.js";
import "core-js/modules/es.array-buffer.transfer.js";
import "core-js/modules/es.array-buffer.transfer-to-fixed-length.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.to-reversed.js";
import "core-js/modules/es.typed-array.to-sorted.js";
import "core-js/modules/es.typed-array.with.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/web.dom-exception.stack.js";
import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import store from './store/index';
import VueI18n from 'vue-i18n';
import CanvasPlugin from 'configurator-base-app';
import Cookies from 'vue-cookies';
import vuetify from './plugins/vuetify';
import VueWaypoint from 'vue-waypoint';
import { EventBus } from './plugins/EventBus';
window.configuratorEventBus = EventBus;
import 'animate.css/animate.min.css';
import './theme/custom.less';
import './assets/configurator.less';
Vue.use(VueI18n);
Vue.use(VueWaypoint);
Vue.use(Cookies);
const i18n = new VueI18n({
  locale: (_navigator$language = navigator.language) !== null && _navigator$language !== void 0 ? _navigator$language : 'IT',
  fallbackLocale: 'EN',
  messages: {} // inizialmente vuoto, lo popolerai dinamicamente
});
const settings = {
  VUE_APP_REST_URL: `${process.env.VUE_APP_REST_URL}`,
  VUE_APP_CONFIG_IDENTIFIER: `${process.env.VUE_APP_CONFIG_IDENTIFIER}`,
  // VUE_APP_CONFIG_ESCLUSIVA: `${process.env.VUE_APP_CONFIG_ESCLUSIVA}`,
  VUE_APP_COLORS_URL: `${process.env.VUE_APP_COLORS_URL}`,
  VUE_APP_AUTENTICATION_HASH: `${process.env.VUE_APP_AUTENTICATION_HASH}`,
  VUE_APP_CONFIG_MODE: `${process.env.VUE_APP_CONFIG_MODE}`,
  VUE_APP_MODEL_URL: `${process.env.VUE_APP_MODEL_URL}`,
  VUE_APP_CONFIG_DATABASE: `${process.env.VUE_APP_CONFIG_DATABASE}`,
  VUE_APP_SENDGRID_SHARE_MAIL_TEMPLATE_ID: process.env.VUE_APP_SENDGRID_SHARE_MAIL_TEMPLATE_ID,
  VUE_APP_HANDLE_SUBLINE_TEMPLES: `${process.env.VUE_APP_HANDLE_SUBLINE_TEMPLES}`,
  VUE_APP_MULTILINETEMPLES: `${process.env.VUE_APP_MULTILINETEMPLES}`
};
Vue.prototype.$iperStoresMode = process.env.VUE_APP_IPER_STORES_MODE;
Vue.use(CanvasPlugin, {
  store,
  settings
});
Vue.config.productionTip = false;
Vue.filter('capitalize', str => {
  if (typeof str !== 'string') return '';
  const strLower = str.toLowerCase();
  return strLower.charAt(0).toUpperCase() + strLower.slice(1);
});
Vue.filter('upperCase', s => {
  if (typeof s !== 'string') return '';
  return s.toUpperCase();
});
Vue.filter('decodeLensModel', l => {
  const map = {
    'MF1.50SF-UC': 'MONOFOCALE 1.50 SFERICA-UC',
    'MF1.56SF-HMC': 'MONOFOCALE 1.56 SFERICA-HMC',
    'MF1.56SF-HMC BLUCUT': 'MONOFOCALE 1.56 SFERICA-HMC BLUCUT',
    'MF1.60AS-SHMC': 'MONOFOCALE 1.60 ASFERICA-SHMC',
    'MF1.67AS-SHMC': 'MONOFOCALE 1.67 ASFERICA-SHMC'
  };
  return map[l] || l;
});
const mountApp = () => {
  new Vue({
    i18n,
    store,
    vuetify,
    render: h => h(App),
    async created() {
      if (process.env.VUE_APP_CONFIG_MODE === 'false') {
        try {
          // @ts-ignore
          const response = await this.$rest.getCountryCode();
          i18n.locale = response.data;
          // @ts-ignore
          this.$rest.getTranslations().then(translations => {
            const messages = translations.data;
            for (const key in messages) {
              const allLocaleMessages = messages[key]["message"];
              const availableLocaleMessages = [];
              // Check which messages are already translated
              // Don't consider all the other ones
              for (const [msg, translated] of Object.entries(allLocaleMessages)) {
                if (translated != "") {
                  availableLocaleMessages[msg] = translated;
                }
              }
              i18n.setLocaleMessage(key, {
                message: availableLocaleMessages
              });
            }
          });
        } catch (err) {
          console.error('Errore caricamento traduzioni:', err);
        }
        console.log("MODALITA SITO");
        // @ts-ignore
        Vue.component('Canvas3d', this.$canvas3d);
        // Modalità configuratore
        Vue.$cookies.set("_identity", process.env.VUE_APP_AUTENTICATION_HASH, "30d");
        this.$store.dispatch("configurator/user/getUserData");
        let sessionId = localStorage.getItem('cfg-session-id');
        this.$store.commit('setSessionId', localStorage.getItem('cfg-session-id'));
        this.$store.dispatch("configurator/user/setSessionId", sessionId);
        if (!sessionId) {
          const array = new Uint8Array(16);
          window.crypto.getRandomValues(array);
          sessionId = btoa(String.fromCharCode(...array));
          localStorage.setItem('cfg-session-id', sessionId);
          console.log("new session id", sessionId);
        }
        this.$store.commit('setSessionId', sessionId);
      } else {
        console.log("MODALITA CONFIGURATORE");
        // @ts-ignore
        Vue.component('Canvas3d', this.$canvas3d);
        try {
          // @ts-ignore
          const response = await this.$rest.getCountryCode();
          i18n.locale = response.data;
          // @ts-ignore
          this.$rest.getTranslations().then(translations => {
            const messages = translations.data;
            for (const key in messages) {
              const allLocaleMessages = messages[key]["message"];
              const availableLocaleMessages = [];
              // Check which messages are already translated
              // Don't consider all the other ones
              for (const [msg, translated] of Object.entries(allLocaleMessages)) {
                if (translated != "") {
                  availableLocaleMessages[msg] = translated;
                }
              }
              i18n.setLocaleMessage(key, {
                message: availableLocaleMessages
              });
            }
          });
        } catch (err) {
          console.error('Errore caricamento traduzioni:', err);
        }
      }
    }
  }).$mount('#cfg-demenego');
};
mountApp();